module.exports = __webpack_public_path__ + "static/media/undraw_growth_analytics_8btt.386b0545.svg";